import uploadcare from 'uploadcare-widget';
import uploadcareTabEffects from 'uploadcare-widget-tab-effects'

(function ($) {

	function WCU(options) {
		console.log('WCU initialization');
		if (!options) {
			throw new Error('No options passed to WCU constructor');
		} else if (!options.publicKey) {
			throw new Error('No public key passed to WCU constructor');
		} else if (!options.siteUrl) {
			throw new Error('No siteUrl passed to WCU constructor');
		} else if (!options.userId) {
			throw new Error('No userId passed to WCU constructor');
		}

		this.options = $.extend({}, WCU.defaults, options);
		console.log(this.options);
		this.setup();
	}

	WCU.prototype.setup = function () {
		let self = this;
		uploadcare.registerTab('preview', uploadcareTabEffects);
		const widget = uploadcare.Widget("#uploader", {
			publicKey: this.options.publicKey,
			metadata: {
				'siteUrl': self.options.siteUrl,
				'userId': self.options.userId,
			}
		});

		widget.onUploadComplete(fileInfo => {
			console.log(fileInfo);
			$('#image-uuid').val(fileInfo.uuid);
			$('#image-modification').val(fileInfo.cdnUrlModifiers);
			$('#image-filename').val(fileInfo.name);
			this.send({
				'uuid': fileInfo.uuid,
				'originalUrl': fileInfo.originalUrl,
				'fileName': fileInfo.name,
				'cdnUrlModifiers': fileInfo.cdnUrlModifiers,
			});
		});

		$('body').on('click', '#wcu-image img', function (event) {
			event.preventDefault();
			widget.openDialog(null);
		});
	}

	WCU.prototype.send = function (data) {
		let self = this;
		$.ajax({
			type: 'post',
			url: self.options.apiRoute,
			data: data,
			dataType: 'json',
			beforeSend: function (xhr) {
				xhr.setRequestHeader('X-WP-Nonce', self.options.nonce);
			},
			success: function (response) {
				console.log(response);
				let wcuImage = $('#wcu-image');
				wcuImage.empty();
				if (self.isImage(response.file_name)) {
					wcuImage.append('<img class="wcu-image-thumbnail" src="' + response.thumbnail_url + '" alt="">');
				}
			},
		});
	}

	WCU.prototype.isImage = function (url) {
		return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
	}

	window.WCU = WCU;

})(jQuery);
